import { useMutation, useQueryClient } from '@tanstack/react-query'
import { SHOP_QUERY_KEYS } from '@/modules/shop/constants'
import { ShopPurchasesService } from '@/modules/shop/api/services'
import { toast } from 'sonner'
import type { paths } from '@/schema'
import showErrorToast from '@/common/utils/showErrorToast'

type ProcessPurchaseBody =
	paths['/api/admin/shop/purchases/{id}/process']['patch']['requestBody']['content']['application/json']
type ProcessPurchaseResponse =
	paths['/api/admin/shop/purchases/{id}/process']['patch']['responses']['200']['content']['application/json']

const useMutationProcessPurchase = () => {
	const queryClient = useQueryClient()

	return useMutation<
		ProcessPurchaseResponse,
		Error,
		{ id: string; data: ProcessPurchaseBody }
	>({
		mutationFn: ({ id, data }) =>
			ShopPurchasesService.processPurchase(id, data),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: SHOP_QUERY_KEYS.PURCHASES.ALL })
			toast.success('ประมวลผลคำสั่งซื้อสำเร็จ')
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})
}

export default useMutationProcessPurchase
